import React, { useCallback, useEffect, useMemo } from "react";
import LogNav from "../layout/LoggedNav";
import ENUMS from "../../utils/ENUMS.js";
import axios from "axios";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Formik, useFormik } from "formik";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import {
  getClubProfile,
  saveClubProfileDetails,
  changeClubProfilePassword,
} from "../../services/apiService";
import { getAuthData } from "../../services/authService";
import { useHistory } from "react-router-dom";
import { cleanSpaces, clearAllSpace, validateMobile } from "../../utils/helper";

toast.configure();
const auth = getAuthData();
const validationSchema = Yup.object({
  old_password: Yup.string().min(6).required("Required!"),
  password: Yup.string().min(6).required("Required!"),
  new_password: Yup.string().min(6).required("Required!"),
});

const validate = (values) => {
  const errors = {};
  if (!values.old_password) {
    errors.old_password = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  if (!values.confirm_password) {
    errors.confirm_password = "Required";
  } else if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/.test(values.password)) {
    errors.password =
      "Must Contain 8 Characters, 1 Uppercase, 1 Lowercase, 1 Number ";
  } else if (values.password != values.confirm_password) {
    errors.confirm_password = "Password Mismatch";
  }

  return errors;
};
const profileValidationSchema = Yup.object({
  first_name: Yup.string().required("Required!"),
  email: Yup.string().email("Invalid email").required("Required!"),
  phone_no: Yup.string().required("Required!"),
  website_url: Yup.string().required("Required!"),
  address1: Yup.string().required("Required!"),
  address2: Yup.string().required("Required!"),
  town: Yup.string().required("Required!"),
  country: Yup.string().required("Required!"),
  post_code: Yup.string().required("Required!"),
});

const MobileNoFormatter = ({ value, onChange }) => {
  // const [isFocused, setIsFocused] = useState(false)

  // const formattedVal = useMemo(() => {
  //
  //     let _formattedVal = ""
  //
  //     for (const char of value) {
  //         if (_formattedVal.length === 4 || _formattedVal.length === 8) _formattedVal += " "
  //
  //         _formattedVal += char;
  //     }
  //
  //
  //     return _formattedVal
  //
  // }, [value])

  return (
    <input
      className="form__input-md"
      onChange={(e) => {
        // const val = cleanSpaces( e.target.value.replace(/\D/g, ""))
        // const val = e.target.value
        // console.log(e.target.value)
        const val = clearAllSpace(e.target.value || "");
        // const val = cleanSpaces(e.target.value || "")
        onChange(val, "club_profile", "phone_no");
      }}
      // onFocus={() => setIsFocused(true)}
      // onBlur={() => setIsFocused(false)}
      type="text"
      placeholder=""
      name=""
      value={value}
      pattern="[0-9 ]+"
      // value={isFocused ? value : formattedVal}
    />
  );
};

const AccClub = () => {
  const token = localStorage.getItem(ENUMS.AUTH);
const [originalEmail, setOriginalEmail] = useState("");

  const [details, setDetails] = useState([{}]);
  const [isEmail, setIsEmail] = useState("");
  const [isSameEmail, setSameIsEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [passwordShown, setPasswordShown] = useState(false);
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [repeatPasswordShown, setRepeatPasswordShown] = useState(false);
  const [passwordDetails, setPasswordDetail] = useState({
    old_password: "",
    password: "",
    confirm_password: "",
  });
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [updatePassword, setUpdatePassword] = useState(false);

  // For Loqate
  const [suggestionList, setSuggestionList] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userInput, setUserInput] = useState();

  // For retreiving the address
  const retrieveAddress = (Key, Id) => {
    var Field1Format = "";
    var url =
      "https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws";
    var params = "";
    params += "&Key=" + encodeURIComponent(Key);
    params += "&Id=" + encodeURIComponent(Id);
    params += "&Field1Format=" + encodeURIComponent(Field1Format);

    axios
      .post(url, params, {
        "Content-type": "application/x-www-form-urlencoded",
      })
      .then((res) => {
        const fll_address = res.data.Items[0];
        let address_line1, address_line2;
        address_line1 = `${fll_address.Label.split("\n").at(0)}`;
        address_line2 = fll_address.Line1;

        if (address_line1 === address_line2) {
          address_line1 = address_line1.split(" ").at(0);
          address_line2 = address_line2.split(" ").at(1);
        }

        setDetails([
          {
            ...details[0],

            club_address: {
              address1: address_line1,
              address2: address_line2,
              town: fll_address.City,
              country: fll_address.CountryName,
              post_code: fll_address.PostalCode,
            },
          },
        ]);
      })
      .catch((err) => console.log(err, "error"));
  };

  // For handling the click event on suggestion
  const handleClick = async (e, Id, Description) => {
    const fullAddress = e.currentTarget.innerText.split(",");
    // console.log(Id, "Item");
    const Key = "NH12-UF93-HD94-AB92";

    if (Description.includes("Addresses")) {
      handleChange(e, Id);
    } else {
      retrieveAddress(Key, Id);
      setShowSuggestions(false);
      setSuggestionList([]);
      setActiveSuggestion(0);
    }
  };

  // For Rendering the Suggestions
  const renderSuggestions = () =>
    suggestionList.map((item, index) => {
      const { Id, Description, Text } = item;

      let activeClass;
      if (index === activeSuggestion) {
        activeClass = "suggestion-active";
      }

      // console.log(Id, Text, Description);

      return (
        <li
          className={
            activeClass === "suggestion-active"
              ? "suggestion-active"
              : "suggestion"
          }
          onClick={(e) => {
            handleClick(e, Id, Description);
          }}
          key={Id}
        >
          <strong>
            <small>{`${Text}, ${Description}`}</small>
          </strong>
        </li>
      );
    });

  // For Address Search
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      setShowSuggestions(false);
      const selectedInput = suggestionList[activeSuggestion];
      setActiveSuggestion(0);
      // console.log(selectedInput, "selected");
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      setActiveSuggestion(activeSuggestion - 1);
      // console.log(activeSuggestion, "activesuggestion")
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === suggestionList.length - 2) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  // For Address Search
  const handleChange = (e, secondFind) => {
    setShowSuggestions(true);
    //   SetinitValll({ ...initValll, address: e.target.value });
    setUserInput(userInput);
    setSuggestionList([]);
    let Text = e.target.value;
    let Container = "";
    if (secondFind !== undefined) {
      Container = secondFind;
      //   console.log(formik.values.address, " fromik address");
      Text = details[0].club_address.address1;
    }
    const Key = "NH12-UF93-HD94-AB92",
      IsMiddleware = false,
      Origin = "",
      Countries = "GB",
      Limit = "10",
      Language = "en-us",
      url1 =
        "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws";
    var params = "";
    params += "&Key=" + encodeURIComponent(Key);
    params += "&Text=" + encodeURIComponent(Text);
    params += "&IsMiddleware=" + encodeURIComponent(IsMiddleware);
    params += "&Container=" + encodeURIComponent(Container);
    params += "&Origin=" + encodeURIComponent(Origin);
    params += "&Countries=" + encodeURIComponent(Countries);
    params += "&Limit=" + encodeURIComponent(Limit);
    params += "&Language=" + encodeURIComponent(Language);

    if (Text.length >= 3) {
      axios
        .post(url1, params, {
          "Content-type": "application/x-www-form-urlencoded",
        })
        .then(({ data }) => {
          const items = data.Items;
          // console.log(items, 'items');
          setSuggestionList(items);
          // console.log(suggestionList,"Suggestion List");

          // setSuggestionList(data.Items);
        })
        .catch((err) => console.log(err));
    }
  };

  const getUserClubDetails = () => {
    getClubProfile(token).then((data) => {
      console.log("club details", data);
      setIsEmail(data.data.data.user.email);
          setOriginalEmail(data.data.data.user.email); 

      if (data && data.data?.status === "SUCCESS") {
        setDetails([data.data.data || {}]);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getUserClubDetails();
  }, []);

  const onChangeValue = (input, key1Value, key2Value) => {
    const isTypeVal = !input?.target;
    let customDetails = details[0];
    customDetails[key1Value][key2Value] = isTypeVal
      ? input
      : input.target.value;
    setSameIsEmail(customDetails.user.email);

    setDetails([customDetails]);
  };

 const onSaveProfileDetails = () => {
  let userData = {
    ...details[0].user,
  };
  userData["role"] = userData["role"].id;

  const clubDetails = {
    user_data: userData,
    club_profile_data: details[0].club_profile,
    club_address: details[0].club_address,
  };

  console.log(clubDetails, "clubDetails");
  setLoading(true);

  saveClubProfileDetails(token, clubDetails)
    .then((data) => {
      if (data && data.data?.status === "SUCCESS") {
        //  Check if email actually changed
        if (details[0]?.user?.email !== originalEmail) {
          setUpdateSuccess(true);
          toast.success("Email successfully updated");

          // Logout flow
          setTimeout(function () {
            localStorage.clear();
            history.replace({ pathname: "/club-login" });
            window.location.reload(false);
          }, 1000);
        } else {
          //  No email change, just show success
          setUpdateSuccess(true);
          toast.success("Profile successfully updated");
        }
      }
      setLoading(false);
    })
    .catch((err) => {
      toast.error("Profile update server error");
      setLoading(false);
    });
};

  let history = useHistory();

  const onChangePassword = () => {
    const clubPassword = formik.values;
    console.log(clubPassword, "password");
    setLoading(true);
    changeClubProfilePassword(token, clubPassword)
      .then((data) => {
        console.log("change password response", data);
        if (data && data.data?.status === "SUCCESS") {
          setUpdatePassword(true);
        } else {
          toast.error("Old Password is incorrect");
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Password Mismatch or Old Password is incorrect");
        setLoading(false);
      });
  };

  const onChangePasword = (input, keyValue) => {
    let customPasswords = passwordDetails[0];
    customPasswords[keyValue] = input.target.value;
    setPasswordDetail([customPasswords]);
  };

  const formik = useFormik({
    initialValues: passwordDetails,
    validate,
    onSubmit: () => onChangePassword(),
    enableReinitialize: true,
  });

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    // console.log(e,"show pass")
    setPasswordShown(!passwordShown);
  };
  const placeholderMap = {
  first_name: "First Name",
  email: "Email Address",
  phone_no: "Phone Number",
  website_url: "Website URL",
  address1: "Address Line 1",
  address2: "Address Line 2",
  town: "Town/City",
  country: "Country",
  post_code: "Postal Code",
};
  const toggleNewPassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    // console.log(e,"show pass")
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleRepeatPassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    // console.log(e,"show pass")
    setRepeatPasswordShown(!repeatPasswordShown);
  };
  return (
   <section className="club_Login">
  <ToastContainer />
  <div className="page-width">
    <div className="acchome-block gap-block-section">
      <h1 className="cd-pass--title text-jost-sb-50"></h1>

      <div className="acchome__wrap">
        <div className="accclub__box">
          {/* LEFT - PROFILE FORM */}
          <div className="accclub__box__left">
            {details.length > 0 && (
<Formik
      initialValues={{
        first_name: details[0]?.user?.first_name || "",
        email: details[0]?.user?.email || "",
        phone_no: details[0]?.club_profile?.phone_no || "",
        website_url: details[0]?.club_profile?.website_url || "",
        address1: details[0]?.club_address?.address1 || "",
        address2: details[0]?.club_address?.address2 || "",
        town: details[0]?.club_address?.town || "",
        country: details[0]?.club_address?.country || "",
        post_code: details[0]?.club_address?.post_code || "",
      }}
      enableReinitialize={true}
      validationSchema={profileValidationSchema}
      onSubmit={(values) => onSaveProfileDetails(values)}
    >
      {(formik) => (
        <form onSubmit={formik.handleSubmit}>
          <div className="accclub__box__left__sec1">
            <h2 className="accclub__box__left__sec2-txt text-jost-sb-24">
              Your Club Contact Details
            </h2>
            {['first_name', 'email', 'phone_no', 'website_url'].map((field, index) => (
              <div className="errors_container" key={index}>
                <input
                  className="form__input-md"
                  type="text"
                  name={field}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values[field]}
                  placeholder={placeholderMap[field]}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <div className="errors" style={{ color: "red" }}>
                    * {formik.errors[field]}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="accclub__box__left__sec2">
            <h2 className="accclub__box__left__sec2-txt text-jost-sb-24">Your Club Address</h2>
            {['address1', 'address2', 'town', 'country', 'post_code'].map((field, index) => (
              <div className="errors_container" key={index}>
                <input
                  className="form__input-md"
                  type="text"
                  name={field}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values[field]}
                  placeholder={placeholderMap[field]}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <div className="errors" style={{ color: "red" }}>
                    * {formik.errors[field]}
                  </div>
                )}
              </div>
            ))}

            <div className="accclub__box__left__sec2-links">
              <button type="submit" className="res-btn-primary">
                Save Profile
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
            )}
          </div>

          {/* RIGHT - PASSWORD FORM */}
          <div className="accclub__box__right">
 <Formik
                    initialValues={passwordDetails}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                  >
                    <form
                      onSubmit={formik.handleSubmit}
                      className="accclub__box__right"
                    >
                      <h2 className="accclub__box__right-txt text-jost-sb-24">
                        Update password
                      </h2>
                      <div className="errors_container">
                        <input
                          className="form__input-md"
                          name="old_password"
                          type={passwordShown ? "text" : "password"}
                          placeholder="Old password"
                          onChange={formik.handleChange}
                          value={formik.values.old_password}
                        />
                        <span onClick={togglePassword}>
                          {passwordShown === true ? (
                            <img
                              src={
                                require("../../assets/images/password_img/show.svg")
                                  .default
                              }
                              alt=""
                            />
                          ) : (
                            <img
                              src={
                                require("../../assets/images/password_img/hide.svg")
                                  .default
                              }
                              alt=""
                            />
                          )}
                        </span>
                        {formik.touched["old_password"] &&
                          (formik.errors.old_password ? (
                            <div className="errors" style={{ color: "red" }}>
                              * {formik.errors.old_password}
                            </div>
                          ) : null)}
                      </div>

                      <div className="errors_container">
                        <input
                          className="form__input-md"
                          name="password"
                          type={newPasswordShown ? "text" : "password"}
                          placeholder="New password"
                          onChange={formik.handleChange}
                          value={formik.values.password}
                        />
                        <span onClick={toggleNewPassword}>
                          {newPasswordShown === true ? (
                            <img
                              src={
                                require("../../assets/images/password_img/show.svg")
                                  .default
                              }
                              alt=""
                            />
                          ) : (
                            <img
                              src={
                                require("../../assets/images/password_img/hide.svg")
                                  .default
                              }
                              alt=""
                            />
                          )}
                        </span>
                        {formik.touched["password"] &&
                          (formik.errors.password ? (
                            <div className="errors" style={{ color: "red" }}>
                              * {formik.errors.password}
                            </div>
                          ) : null)}
                      </div>
                      <div className="errors_container">
                        <input
                          className="form__input-md"
                          name="confirm_password"
                          type={repeatPasswordShown ? "text" : "password"}
                          placeholder="Confirm new password"
                          onChange={formik.handleChange}
                          value={formik.values.confirm_password}
                        />
                        <span onClick={toggleRepeatPassword}>
                          {repeatPasswordShown === true ? (
                            <img
                              src={
                                require("../../assets/images/password_img/show.svg")
                                  .default
                              }
                              alt=""
                            />
                          ) : (
                            <img
                              src={
                                require("../../assets/images/password_img/hide.svg")
                                  .default
                              }
                              alt=""
                            />
                          )}
                        </span>
                        {formik.touched["confirm_password"] &&
                          (formik.errors.confirm_password ? (
                            <div className="errors" style={{ color: "red" }}>
                              * {formik.errors.confirm_password}
                            </div>
                          ) : null)}
                      </div>
                      <div className="accclub__box__right-links">
                        {updatePassword && (
                          <h2 className="text-jost-sb-19-lg">Updated</h2>
                        )}
                        <button type="submit" className="res-btn-primary">
                          Update Password
                        </button>
                      </div>
                    </form>
                  </Formik>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      // <section className=" club_Login">
      //     <ToastContainer />
      //   <div className="page-width">
      //     <div className="acchome-block gap-block-section">
           
      //         <h1 className="cd-pass--title text-jost-sb-50">
      //         </h1>
      //         {/* <LogNav /> */}

      //         <div className="acchome__wrap">
      //           <div className="accclub__box">
      //             <div className="accclub__box__left">
      //               <div className="accclub__box__left__sec1">
      //                 <h2 className="accclub__box__left__sec2-txt text-jost-sb-24">
      //                   your Clubs contact details
      //                 </h2>

      //                 {details.map(
      //                   (detail) => (
      //                     <>
      //                       <input
      //                         className="form__input-md"
      //                         type="text"
      //                         placeholder=""
      //                         name=""
      //                         onChange={(i) => {
      //                           onChangeValue(i, "user", "first_name");
      //                         }}
      //                         value={`${detail?.user?.first_name || ""}`}
      //                       />
      //                       {/*<input className="form__input-md" type="text" placeholder="" name="" onChange={(i)=>{onChangeValue(i,"user","last_name")}} value={`${detail?.user?.last_name||''}`} />*/}

      //                       <input
      //                         className="form__input-md"
      //                         onChange={(i) => {
      //                           onChangeValue(i, "user", "email");
      //                         }}
      //                         type="text"
      //                         placeholder=""
      //                         name=""
      //                         value={detail?.user?.email || ""}
      //                         name="gname"
      //                         required
      //                       />
      //                       <MobileNoFormatter
      //                         value={detail?.club_profile?.phone_no || ""}
      //                         onChange={onChangeValue}
      //                       />
      //                       {/*<input className="form__input-md"*/}
      //                       {/*       type="number" placeholder="" name=""*/}
      //                       {/*       onChange={(i) => {*/}
      //                       {/*           onChangeValue(i, "club_profile", "phone_no")*/}
      //                       {/*       }}*/}
      //                       {/*       value={`${detail?.club_profile?.phone_no || ''}`}/>*/}
      //                       <input
      //                         className="form__input-md"
      //                         type="text"
      //                         onChange={(i) => {
      //                           onChangeValue(i, "club_profile", "website_url");
      //                         }}
      //                         placeholder=""
      //                         name=""
      //                         value={detail?.club_profile?.website_url || ""}
      //                         required
      //                       />
      //                     </>
      //                   )
      //                   //     console.log(detail,"detail")
      //                 )}
      //               </div>
      //               <div className="accclub__box__left__sec2">
      //                 <h2 className="accclub__box__left__sec2-txt text-jost-sb-24">
      //                   Your Club Address
      //                 </h2>
      //                 {details.map((detail) => (
      //                   <>
      //                     <div className="address__suggestion">
      //                       <input
      //                         className="form__input-md"
      //                         type="text"
      //                         id="address"
      //                         placeholder="Start to type your address…"
      //                         onKeyDown={handleKeyDown}
      //                         name="address"
      //                         onChange={(e) => {
      //                           onChangeValue(e, "club_address", "address1");
      //                           handleChange(e);
      //                         }}
      //                         autocomplete="none"
      //                         value={detail?.club_address?.address1 || ""}
      //                       />
      //                       <ul className="suggestion__items">
      //                         {suggestionList !== [] &&
      //                           showSuggestions &&
      //                           renderSuggestions()}
      //                         {suggestionList === [] && (
      //                           <li className="suggestion">
      //                             <strong>
      //                               <small>There are no results</small>
      //                             </strong>
      //                           </li>
      //                         )}
      //                       </ul>
      //                     </div>
      //                     <input
      //                       className="form__input-md"
      //                       type="text"
      //                       onChange={(i) => {
      //                         onChangeValue(i, "club_address", "address2");
      //                       }}
      //                       value={detail?.club_address?.address2 || ""}
      //                       placeholder="address 2"
      //                       required
      //                     />
      //                     <input
      //                       className="form__input-md"
      //                       type="text"
      //                       onChange={(i) => {
      //                         onChangeValue(i, "club_address", "town");
      //                       }}
      //                       value={detail?.club_address?.town || ""}
      //                       required
      //                     />
      //                     <input
      //                       className="form__input-md"
      //                       type="text"
      //                       onChange={(i) => {
      //                         onChangeValue(i, "club_address", "country");
      //                       }}
      //                       value={detail?.club_address?.country || ""}
      //                       required
      //                     />
      //                     <input
      //                       className="form__input-md"
      //                       type="text"
      //                       onChange={(i) => {
      //                         onChangeValue(i, "club_address", "post_code");
      //                       }}
      //                       value={detail?.club_address?.post_code || ""}
      //                       required
      //                     />
      //                   </>
      //                 ))}
      //                 <div className="accclub__box__left__sec2-links">
                        
      //                   <a
      //                     onClick={onSaveProfileDetails}
      //                     target="_self"
      //                     className="res-btn-primary"
      //                   >
      //                     Save Profile
      //                   </a>
      //                 </div>
      //               </div>
      //             </div>
      //             <Formik
      //               initialValues={passwordDetails}
      //               validationSchema={validationSchema}
      //               enableReinitialize={true}
      //             >
      //               <form
      //                 onSubmit={formik.handleSubmit}
      //                 className="accclub__box__right"
      //               >
      //                 <h2 className="accclub__box__right-txt text-jost-sb-24">
      //                   Update password
      //                 </h2>
      //                 <div className="errors_container">
      //                   <input
      //                     className="form__input-md"
      //                     name="old_password"
      //                     type={passwordShown ? "text" : "password"}
      //                     placeholder="Old password"
      //                     onChange={formik.handleChange}
      //                     value={formik.values.old_password}
      //                   />
      //                   <span onClick={togglePassword}>
      //                     {passwordShown === true ? (
      //                       <img
      //                         src={
      //                           require("../../assets/images/password_img/show.svg")
      //                             .default
      //                         }
      //                         alt=""
      //                       />
      //                     ) : (
      //                       <img
      //                         src={
      //                           require("../../assets/images/password_img/hide.svg")
      //                             .default
      //                         }
      //                         alt=""
      //                       />
      //                     )}
      //                   </span>
      //                   {formik.touched["old_password"] &&
      //                     (formik.errors.old_password ? (
      //                       <div className="errors" style={{ color: "red" }}>
      //                         * {formik.errors.old_password}
      //                       </div>
      //                     ) : null)}
      //                 </div>

      //                 <div className="errors_container">
      //                   <input
      //                     className="form__input-md"
      //                     name="password"
      //                     type={newPasswordShown ? "text" : "password"}
      //                     placeholder="New password"
      //                     onChange={formik.handleChange}
      //                     value={formik.values.password}
      //                   />
      //                   <span onClick={toggleNewPassword}>
      //                     {newPasswordShown === true ? (
      //                       <img
      //                         src={
      //                           require("../../assets/images/password_img/show.svg")
      //                             .default
      //                         }
      //                         alt=""
      //                       />
      //                     ) : (
      //                       <img
      //                         src={
      //                           require("../../assets/images/password_img/hide.svg")
      //                             .default
      //                         }
      //                         alt=""
      //                       />
      //                     )}
      //                   </span>
      //                   {formik.touched["password"] &&
      //                     (formik.errors.password ? (
      //                       <div className="errors" style={{ color: "red" }}>
      //                         * {formik.errors.password}
      //                       </div>
      //                     ) : null)}
      //                 </div>
      //                 <div className="errors_container">
      //                   <input
      //                     className="form__input-md"
      //                     name="confirm_password"
      //                     type={repeatPasswordShown ? "text" : "password"}
      //                     placeholder="Confirm new password"
      //                     onChange={formik.handleChange}
      //                     value={formik.values.confirm_password}
      //                   />
      //                   <span onClick={toggleRepeatPassword}>
      //                     {repeatPasswordShown === true ? (
      //                       <img
      //                         src={
      //                           require("../../assets/images/password_img/show.svg")
      //                             .default
      //                         }
      //                         alt=""
      //                       />
      //                     ) : (
      //                       <img
      //                         src={
      //                           require("../../assets/images/password_img/hide.svg")
      //                             .default
      //                         }
      //                         alt=""
      //                       />
      //                     )}
      //                   </span>
      //                   {formik.touched["confirm_password"] &&
      //                     (formik.errors.confirm_password ? (
      //                       <div className="errors" style={{ color: "red" }}>
      //                         * {formik.errors.confirm_password}
      //                       </div>
      //                     ) : null)}
      //                 </div>
      //                 <div className="accclub__box__right-links">
      //                   {updatePassword && (
      //                     <h2 className="text-jost-sb-19-lg">Updated</h2>
      //                   )}
      //                   <button type="submit" className="res-btn-primary">
      //                     Update Password
      //                   </button>
      //                 </div>
      //               </form>
      //             </Formik>
      //           </div>
      //         </div>
            
      //     </div>
      //   </div>
      // </section>
   
  );
};
export default AccClub;
